import React, { Component } from 'react'

export class Popupfilter extends Component {
    constructor(props){
        super(props)
        this.state = {
            air_type: props.data.air_type || '',
            efficiency: props.data.efficiency || '',
            coil: props.data.coil || '',
            swing: props.data.swing || '',
            purify: props.data.purify || ''
        }
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    onSubmit() {
        const data = {
            ...this.state
        }
        this.props.handleFilter(data)
    }

    onSubmitClear() {
        const data = {
            air_type: '',
            efficiency: '',
            coil: '',
            swing: '',
            purify: ''
        }
        this.props.handleFilter(data)
    }

    render() {
        return (
            <div className="popup-filter">
                <div className="bg-popup" onClick={() => this.props.handleClose()}></div>
                <div className="popup-inner">
                    <div className="popup-content">
                        <h4 className="title">FILTER</h4>
                        <form>
                            <div className="form-item">
                                <label htmlFor="air_type">ระบบ</label>
                                <select name="air_type" id="air_type" value={this.state.air_type} onChange={(value) => this.handleChange(value)} >
                                    <option value="">ทั้งหมด</option>
                                    <option value="INVERTER">INVERTER</option>
                                    <option value="FIXSPEED">FIXSPEED</option>
                                </select>
                            </div>
                            <div className="form-item">
                                <label htmlFor="efficiency">เบอร์ 5</label>
                                <select name="efficiency" id="efficiency" value={this.state.efficiency} onChange={(value) => this.handleChange(value)} >
                                    <option value="">ทั้งหมด</option>
                                    <option value="ไม่มีเบอร์ 5">ไม่มีเบอร์ 5</option>
                                    <option value="เบอร์ 5 : ไม่มีดาว">เบอร์ 5 : ไม่มีดาว</option>
                                    <option value="เบอร์ 5 : 1 ดาว">เบอร์ 5 : 1 ดาว</option>
                                    <option value="เบอร์ 5 : 2 ดาว">เบอร์ 5 : 2 ดาว</option>
                                    <option value="เบอร์ 5 : 3 ดาว">เบอร์ 5 : 3 ดาว</option>
                                    <option value="เบอร์ 5 : 4 ดาว">เบอร์ 5 : 4 ดาว</option>
                                    <option value="เบอร์ 5 : 5 ดาว">เบอร์ 5 : 5 ดาว</option>
                                </select>
                            </div>
                            <div className="form-item">
                                <label htmlFor="coil">คอยล์</label>
                                <select name="coil" id="coil" value={this.state.coil} onChange={(value) => this.handleChange(value)} >
                                    <option value="">ทั้งหมด</option>
                                    <option value="ทองแดง">ทองแดง</option>
                                    <option value="อลูมิเนียม">อลูมิเนียม</option>
                                </select>
                            </div>
                            <div className="form-item">
                                <label htmlFor="swing">สวิง</label>
                                <select name="swing" id="swing" value={this.state.swing} onChange={(value) => this.handleChange(value)} >
                                    <option value="">ทั้งหมด</option>
                                    <option value="ขึ้นลง">ขึ้นลง</option>
                                    <option value="ขึ้นลง - ซ้ายขวา">ขึ้นลง - ซ้ายขวา</option>
                                </select>
                            </div>
                            <div className="form-item">
                                <label htmlFor="purify">ฟอกอากาศ</label>
                                <select name="purify" id="purify" value={this.state.purify} onChange={(value) => this.handleChange(value)} >
                                    <option value="">ทั้งหมด</option>
                                    <option value="แผ่นฟอก">แผ่นฟอก</option>
                                    <option value="ฟอกไฟฟ้า">ฟอกไฟฟ้า</option>
                                    <option value="ไม่มีระบบฟอก">ไม่มีระบบฟอก</option>
                                </select>
                            </div>
                        </form>
                        <div className="btn-wrapper">
                            <div className="btn-item btn-reset" onClick={() => this.onSubmitClear()}>ล้างค่า</div>
                            <div className="btn-item btn-submit" onClick={() => this.onSubmit()}>ค้นหา</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}